const VISIT_OPTIONS = [
  { value: "unknown", label: "—" },
  { value: "visited", label: "Megvolt" },
  { value: "no_show", label: "Nem jött" },
];

function SubscriberStatusCell({ entry, saving, onUpdate }) {
  return (
    <div className="admin-dash-status-cell">
      <label className="admin-dash-status-field">
        <span className="visually-hidden">Látogatás</span>
        <select
          className={`admin-dash-status-select admin-dash-status-select-${entry.visitStatus || "unknown"}`}
          value={entry.visitStatus || "unknown"}
          disabled={saving}
          onChange={(event) =>
            onUpdate(entry.email, { visitStatus: event.target.value })
          }
        >
          {VISIT_OPTIONS.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </label>
    </div>
  );
}

export default SubscriberStatusCell;
